import $ from 'jquery';
import Swiper from 'swiper';

import Section from '../Section';
import Media from '../global/Media';
import QuantityControls from '../global/QuantityControls';

export default class Product extends Section {
  constructor(theme, element, pageLoad, isFeaturedProduct = false) {
    super(theme, element, pageLoad);

    this.isFeaturedProduct = isFeaturedProduct;

    // Settings
    this.config = {
      shopifyAjaxAddUrl: '/cart/add.js',
      shopifyAjaxUrl: '/cart.js'
    };

    this.$element = $(element);

    this.sectionId = this.element.dataset.sectionId;
    var productScript = this.element.querySelector('.product-json');
    if (!productScript) {
      // Product is not loaded, there is either no product section or the product is not selected
      return;
    }
    this.product = JSON.parse(productScript.textContent);
    this.$selects = this.$element.find('.selector-wrapper select, .product-option-select select').sort((a, b) => {return a.id.replace(/\D/g,'') - b.id.replace(/\D/g,'');});
    this.$selects.on('change', this.onSelectChange);
    this.$originalSelect = this.$element.find('.original-select');
    this.$old_price = this.$element.find('.compare-at-price .money');
    this.$price = this.$element.find('#price-field');
    this.$cart = this.$element.find('#purchase');
    this.$cartCount = $('.cart-item-count-header--quantity');
    this.$spb = this.$element.find('.shopify-payment-button');
    this.$sale = this.$element.find('.sale-badge,.compare-at-price');
    this.$sale_price = this.$element.find('.compare-at-price');
    this.$pricePerUnit = this.$element.find('.product-page--pricing--price-per-unit');
    this.$variantPercentageWrapper = this.$element.find('.variant-percentage-wrapper');
    this.$variantValueWrapper = this.$element.find('.variant-value-wrapper');
    this.$variantValue = this.$element.find('.variant-value');
    this.$featuredImageWrapper = this.$element.find('.featured-image-div');
    this.$featuredImage = this.$element.find('.product-main-image');
    this.$addToCartForm = this.$element.find('#add-to-cart-form');
    this.$mobileSlider = this.$element.find('.mobile-product-slider');
    this.$cartSliderWrapper = $('#cartSlideoutWrapper');
    this.$thumbnails = this.$element.find('.product-single__thumbnail');
    this.$swatchGroups = this.$element.find('#add-to-cart-form').find('.swatch');
    this.$swatchInputs = this.$element.find('#add-to-cart-form').find('.swatch input');
    this.$swatchLabels = this.$element.find('#add-to-cart-form').find('.swatch label');
    this.$sku = this.$element.find('.indiv-product-sku-text');
    this.$stockLevelIndicator = this.$element.find('stock-level-indicator');
    this.storeAvailabilityContainer = this.$element.find('[data-store-availability-container]');
    this.zoomSelector = '.zoomImg';
    this.addedTextTimeout = null;
    this.slider = this.initializeSlider();

    // Load media
    this.mediaById = new Map();
    var isMobile = window.matchMedia('screen and (max-width: 767px)').matches;
    var autoload = !isMobile;
    this.mediaTarget = this.element.querySelector('.product-single__medias');
    Array.prototype.forEach.call(
      this.element.querySelectorAll('.product-single__thumbnail:not(.swiper-slide-duplicate)'),
      (media_root) => {
        var media = new Media(this.theme, media_root, isMobile || this.isFeaturedProduct ? media_root : this.mediaTarget, autoload);
        this.mediaById.set(media_root.dataset.mediaId, media);

        // Enable/disable drag to next slide when media is paused/playing
        media_root.addEventListener('media-play', () => { this.slider.allowTouchMove = false; });
        media_root.addEventListener('media-pause', () => { this.slider.allowTouchMove = true; });
      },
    );

    if (this.$element.find('.product-single__view-in-space').length > 0) {
      // The "View in your space" button is there => we have a model. Load XR library so
      // it can show/hide the button based on browser/device support
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
      ]);
    }

    var self = this;

    if (this.$swatchLabels.length > 0) {
      this.$swatchLabels.each((index, label) => {
        $(label).on('keypress', (e) => {
          var key = e.which;
          // Enter key
          if (key == 13) {
            // Check swatch input.
            const labelFor = $(e.target).attr('for');
            $('#' + labelFor).prop('checked', true);
            self.onSwatchChange();
          }
        });
      });
    }

    if (this.$swatchInputs.length > 0) {
      // Check swatches based on variant
      const optionSwatchGroups = this.$swatchGroups.filter(function() { return typeof $(this).data('option-index') !== 'undefined' ? ($(this).data('option-index') !== 0) : false });
      this.optionInputs = optionSwatchGroups.children()
      this.onSwatchChange();
    } else {
      // Fill variant based on selection
      const optionSelectGroups = this.$selects.filter(function() { return typeof $(this).data('option-index') !== 'undefined' ? ($(this).data('option-index') !== 0) : false });
      this.optionInputs = optionSelectGroups.children();
      this.onSelectChange();
    }

    this.$cart.on('click', (e) => {
      e.preventDefault();
      this.disableCartButton();
      this.addToCart();
    });

    // Ensure the change event is fired on the form when variants changed (for Shop Pay Installments)
    this.selects = this.element.querySelectorAll('.selector-wrapper select, .product-option-select select');
    this.addToCartForm = this.element.querySelector('#add-to-cart-form');

    this.selects.forEach(select => {
      select.addEventListener('change', function () {
        const event = new Event('change');
        self.addToCartForm.dispatchEvent(event);
      });
    });

    // Handle thumbnail and media click
    this.$thumbnails.off('click keydown').on('click keydown', (e) => {
      if (e.type === 'keydown') {
        if (e.keyCode !== 13 && e.keyCode !== 27) {
          return;
        }
        if (e.target.classList.contains('shopify-model-viewer-ui__button') || e.target.classList.contains('plyr__control')) {
          return;
        }
      }
      e.preventDefault();

      if (e.target.classList.contains('product-single__view-in-space')) {
        // Don't do anything on "view in your space" click, it's handled by Shopify XR library
        return;
      }


      if (e.target.tagName === 'MODEL-VIEWER' || e.target.classList.contains('shopify-model-viewer-ui__controls-overlay')) {
        // Don't do anything on 3d model overlay click, it will trigger an event itself
        return;
      }

      if (e.target.classList.contains('plyr__control')) {
        // Don't do anything on plyr button click
        return;
      }

      if (e.currentTarget.dataset.mediaType === 'image' && this.slider.slidesPerViewDynamic() === 1) {
        // Image is clicked when there are no thumbnails, do nothing
        return;
      }

      const isLoaded = e.currentTarget.classList.contains('product-single__media--loaded');
      const isActive = e.currentTarget.classList.contains('product-single__media--active');

      if (isLoaded && isActive) {
        // Loaded and active media will handle click internally in the component itself
        return;
      }

      this.onMediaElementSelect(e.currentTarget, { load: true, togglePlay: true, focus: true });
    });

    this.$swatchInputs.on('change', this.onSwatchChange);

    this.preloadImages();

    this.loadTabs();

    this.loadSlider();

    this.quantityControls = new QuantityControls(this.theme, this.element);

    this.responsiveTables();
  }

  /* Initialize the product thumbnail slider */
  initializeSlider = () => {
    var product = this;

    var container = this.element.querySelector('div[data-swiper-container]');
    var wrapper = this.element.querySelector('div[data-swiper-wrapper]');

    container.classList.add('swiper-container');
    wrapper.classList.add('swiper-wrapper');

    var thumbnails = this.element.querySelector('.product-single__thumbnails');
    if (!thumbnails) {
      return;
    }
    var numItems = this.element.querySelectorAll('.product-single__thumbnail').length;

    var el = /** @type {HTMLElement} */ (thumbnails.querySelector('.swiper-container'));
    if (!el) {
      return;
    }

    // Do not show arrows or pagination if there is a single media item.
    const pagination = {
      el: el.parentNode.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true,
      renderBullet: (index, className) => {
        return '<span class="' + className + '"><span class="swiper-pagination-bullet-dot"></span></span>';
      },
    };

    var productThumbSlider = new Swiper(el, {
      direction: 'horizontal',
      slidesPerView: 1,
      updateOnImagesReady: true,
      spaceBetween: 20,
      threshold: 10,
      navigation: {
        nextEl: '.thumbs-direction-nav--next',
        prevEl: '.thumbs-direction-nav--prev',
      },
      pagination: pagination,
      loop: !thumbnails.classList.contains('no-arrows'),
      autoHeight: true,
      loopedSlides: 1,
      breakpoints: !this.isFeaturedProduct ?
        {
          768: {
            slidesPerView: el.dataset.slidesPerView,
            direction: el.dataset.direction || 'horizontal',
            autoHeight: false,
          }
        }
        :
        null
    });
    productThumbSlider.on('slideChange', function () {
      // Go to first/last slide when prev/next is clicked on first/last slide
      var slidesPerView = this.slidesPerViewDynamic();

      if (slidesPerView === 1) {
        // One element is displayed => make it active
        product.onMediaElementSelect(this.slides[this.activeIndex], {});
      } else {
        // Multiple elements in view, moving to next should animate to first
        if (this.isEnd) {
          this.slideTo(1);
        } else if (this.isBeginning) {
          this.slideTo(this.slides.length - 1 - slidesPerView);
        }
      }
      fixThumbSliderTabindex(this);
    });
    fixThumbSliderTabindex(productThumbSlider);

    if (numItems <= 1) {
      thumbnails.querySelector('.swiper-pagination-bullets').classList.add('hide');
    }

    const parent = /** @type {HTMLElement} */ (el.parentNode);
    if (productThumbSlider.slidesPerViewDynamic() > 1) {
      parent.classList.add('product-single__thumbnails--carousel');
    }

    var lastBreakpoint = productThumbSlider.currentBreakpoint;
    productThumbSlider.on('resize', function (e) {
      if (this.slidesPerViewDynamic() > 1) {
        parent.classList.add('product-single__thumbnails--carousel');
      } else {
        parent.classList.remove('product-single__thumbnails--carousel');
      }

      if (this.currentBreakpoint != lastBreakpoint) {
        lastBreakpoint = this.currentBreakpoint;
        if (this.currentBreakpoint === 'max') {
          el.classList.add('product-single__thumbnails--mobile');
          product.mediaToMobile();
          productThumbSlider.autoHeight = true;

          thumbnails.classList.toggle('hide', numItems < 1);
        } else {
          el.classList.remove('product-single__thumbnails--mobile');
          product.mediaToDesktop();
          productThumbSlider.autoHeight = false;
          thumbnails.classList.toggle('hide', numItems <= 1);
        }
      }
    });
    if (productThumbSlider.currentBreakpoint === 'max') {
      el.classList.add('product-single__thumbnails--mobile');
      thumbnails.classList.toggle('hide', numItems < 1);
    } else if (productThumbSlider.currentBreakpoint !== undefined) {
      thumbnails.classList.toggle('hide', numItems <= 1);
    }

    const paginationEl = el.parentNode.querySelector('.swiper-pagination');
    paginationEl.addEventListener('keydown', (e) => {
      // Pressing enter on active bullet will active the media and focus it
      if ((/** @type {KeyboardEvent} */ (e)).keyCode === 13) {
        if ($(e.target).index() === productThumbSlider.activeIndex - 1) {
          this.onMediaElementSelect(productThumbSlider.slides[productThumbSlider.activeIndex], { forcePlay: true, focus: true });
        }
      }
    }, { capture: true });

    if (productThumbSlider.device.ios) {
      paginationEl.classList.add('swiper-pagination-hide-focus');
    }

    return productThumbSlider;
  }

  mediaToDesktop = () => {
    // We've switched to desktop, move medias from thumbnains into separate box
    var parent = this.element.querySelector('.product-single__medias');
    this.mediaById.forEach((media) => {
      media.reattach(parent);
      if (media.loaded) {
        parent.classList.add('product-single__thumbnail--loaded');
      } else if (media.selected) {
        parent.classList.add('product-single__media--selected');
        media.load();
      }
    });
  }

  mediaToMobile = () => {
    // We've switched to mobile, move medias from separate box into the thumbnails
    this.mediaById.forEach((media) => {
      var parent = this.element.querySelector('.product-single__thumbnail[data-media-id="' + media.media_id + '"]');
      media.reattach(parent);
    });
  }

  preloadImages = () => {
    $('#product-thumbnails img').each((index, el) => {
      if ($(el).data('zoom-img')) {
        var thisUrl = 'https:' + $(el).data('zoom-img');
        try {
          var img = new Image();
          img.src = thisUrl;
        } catch (e) {
          console.error('Unable to preload image:', e);
        }
      }
    });
  }

  setVariantOptions = (values) => {
    var matchingVariants = this.product.variants.filter((variant) => {
      for (var i = 0; i < values.length; i++) {
        if (values[i] !== variant.options[i]) {
          return false
        }
      }
      return true;
    });
    if (matchingVariants.length === 0) {
      this.updateVariant(null);
    } else {
      this.updateVariant(matchingVariants[0]);
    }
    if(values.length > 1) {
      this.updateVariantStatuses(values);
    }
  };

  updateVariantStatuses = (values) => {
    const selectedOptionOneVariants = this.product.variants.filter(variant => variant.option1 === values[0]);
    const uniqueAvailableOptions = new Set();

    for (let i = 1, len = this.product.options.length; i < len; i++) {
      const selectedPreviousOption = values[i - 1];
      selectedOptionOneVariants
        .filter(variant => variant.available && variant[`option${ i }`] === selectedPreviousOption)
        .forEach(variantOption => {
          uniqueAvailableOptions.add(variantOption[`option${ i + 1 }`]);
        });
    }
    this.updateOptionsAvailability(this.optionInputs, [...uniqueAvailableOptions]);
  }

  updateOptionsAvailability(optionInputs, availableOptionInputsValue) {
    if (this.$swatchInputs.length > 0) {
      this.setSwatchesAvailability(optionInputs, availableOptionInputsValue);
    } else {
      this.setSelectOptionsAvailability(optionInputs, availableOptionInputsValue);
    }
  }

  setSelectOptionsAvailability(listOfOptions, listOfAvailableOptions) {
    const unavailableWithOptionTitle = value => this.theme.translations.unavailable_with_option.replace('[value]', value);
    listOfOptions.each(function() {
      if (listOfAvailableOptions.includes($(this).val())) {
        $(this).text($(this).val().toString());
      } else {
        if(!$(this).is('[data-placeholder]')) $(this).text(unavailableWithOptionTitle($(this).val()));
      }
    });
  }

  setSwatchesAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.each(function() {
      if (listOfAvailableOptions.includes($(this).data('value'))) {
        $(this).removeClass('soldout').addClass('available');
      } else {
        $(this).removeClass('available').addClass('soldout');
      }
    });
  }

  onSelectChange = () => {
    var values = this.$selects.map((index, select) => {
      return $(select).val();
    });

    this.setVariantOptions(values);
  };

  onSwatchChange = () => {
    var values = [];

    this.$addToCartForm.serializeArray().forEach((option) => {
      if (option.name.indexOf('option-') === 0) {
        values[parseInt(option.name.split('-')[1], 10)] = option.value;
      }
    });

    this.setVariantOptions(values);
  };

  onMediaElementSelect = (element, options) => {
    var media = this.mediaById.get(element.dataset.mediaId);
    // Pause all others
    this.mediaById.forEach((otherMedia) => {
      if (otherMedia.media_id !== media.media_id) {
        otherMedia.pause();
        otherMedia.deselect();
      }
    });

    media.select();
    if (options.togglePlay) {
      media.togglePlay();
    } else if (options.forcePlay) {
      media.play();
    } else if (options.load) {
      media.load().then(function () {
        if (options.focus) {
          media.focus();
        }
      });
    }
    if (options.focus) {
      media.focus();
    }
  }

  onVariantSelected = (variant_id) => {
    var matchingVariants = this.product.variants.filter((variant) => {
      return variant.id == variant_id;
    });
    if (matchingVariants.length === 0) {
      this.updateVariant(null);
    } else {
      var variant = matchingVariants[0];
      this.updateVariant(matchingVariants[0]);
      for (var i = 0; i < variant.options.length; i++) {
        const select = /** @type {HTMLSelectElement} */ (this.element.querySelector('#SingleOptionSelector-' + i));
        if (!select) {
          continue;
        }
        select.value = variant.options[i];
        const e = new CustomEvent('change');
        select.dispatchEvent(e);
      }
    }
  };

  storeAvailability = (variantId, productTitle) => {
    var variantSectionUrl = '/variants/' + variantId + '/?section_id=store-availability';

    var storePickupEnabled = this.element.querySelector('.store-pickup-enabled');
    if (!storePickupEnabled) return;

    var availabilityContainer = document.createElement('div');
    availabilityContainer.classList.add('product__store__availability__container');
    var availabilityModal = document.createElement('div');
    availabilityModal.setAttribute('data-store-availability-modal-container', '');

    var targetFP = this.element.querySelector('.featured-product--submit-action');
    var targetEl = this.element.querySelector('.product-page--local-pickup');

    if (!availabilityContainer) return;

    availabilityContainer.innerHTML = '';

    fetch(variantSectionUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (storeAvailabilityHTML) {
        if (storeAvailabilityHTML.trim() === '' || !storeAvailabilityHTML.includes('"store-availability-information"')) {
          return;
        }

        // Remove existing content.
        const prevContent = this.element.querySelector('.product__store__availability__container');
        if (prevContent) {
          prevContent.remove();
        }

        availabilityContainer.innerHTML = storeAvailabilityHTML;
        var stripInnerSection = availabilityContainer.querySelector('.store-availability-container');
        availabilityContainer.innerHTML = stripInnerSection.innerHTML;

        if (targetFP) {
          targetFP.after(availabilityContainer);
          availabilityContainer.after(availabilityModal);
        } else if (targetEl) {
          targetEl.after(availabilityContainer);
          availabilityContainer.after(availabilityModal);
        }

        var storeAvailabilityModalOpen = this.element.querySelector('a[data-store-availability-modal-open]');
        var storeAvailabilityModalProductTitle = this.element.querySelector('h2[data-store-availability-modal-product-title]');

        // Only create modal if open modal element exists
        if (!storeAvailabilityModalOpen) {
          return;
        } else {
          // Open modal
          storeAvailabilityModalOpen.addEventListener('click', function () {
            // Trap focus within modal
            setTimeout(function () {
              var focusableEls = availabilityModal.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
              var firstFocusableEl = focusableEls[0];
              var lastFocusableEl = focusableEls[focusableEls.length - 1];
              var KEYCODE_TAB = 9;

              (/** @type {HTMLElement} */ (availabilityModal)).focus();

              availabilityModal.addEventListener('keydown', function (e) {
                var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

                if (!isTabPressed) {
                  return;
                }

                if (e.shiftKey) /* shift + tab */ {
                  if (document.activeElement === firstFocusableEl) {
                    (/** @type {HTMLElement} */ (lastFocusableEl)).focus();
                    e.preventDefault();
                  }
                } else /* tab */ {
                  if (document.activeElement === lastFocusableEl) {
                    (/** @type {HTMLElement} */ (firstFocusableEl)).focus();
                    e.preventDefault();
                  }
                }

              });
            }, 500);

            var modalContainer = this.element.querySelector('div[data-store-availability-modal-container]');
            var availabilityModal = this.element.querySelector('#StoreAvailabilityModal');
            var htmlBody = document.querySelector('body');
            htmlBody.classList.add('availability-modal--open');
            modalContainer.classList.add('store-availabilities-modal--open');
            availabilityModal.classList.add('open');
            availabilityModal.style = 'visibility: visible;'

            if (htmlBody.classList.contains('availability-modal--open')) {
              modalContainer.addEventListener('click', function () {
                modalContainer.classList.remove('store-availabilities-modal--open');
                htmlBody.classList.remove('availability-modal--open');
                availabilityModal.classList.remove('open');
                availabilityModal.style = 'visibility: hidden;'
              });
            }

            //Modal close button
            var availabilityModalCloseButton = this.element.querySelector('.store-availabilities-modal__close');
            if (availabilityModalCloseButton) {
              availabilityModalCloseButton.addEventListener('click', function () {
                modalContainer.classList.remove('store-availabilities-modal--open');
                htmlBody.classList.remove('availability-modal--open');
                availabilityModal.classList.remove('open');
                availabilityModal.style = 'visibility: hidden;'
              });
            }

          }.bind(this));
        }

        // Update product title
        if (!storeAvailabilityModalProductTitle) {
          return;
        } else {
          storeAvailabilityModalProductTitle.textContent = productTitle;
        }

      }.bind(this));
  };

  handleVariant = (variant) => {
    this.$originalSelect.val(variant.id);
    this.storeAvailability(variant.id, this.product.title);

    var is_sale = variant.compare_at_price && variant.compare_at_price > variant.price;
    this.$sale.toggleClass('hide', !is_sale);
    if (variant.sku) {
      this.$sku.text(variant.sku);
    }
    this.$sku.toggleClass('hide', !variant.sku);

    this.$stockLevelIndicator.attr('data-envy-variant-id', variant.id); 
  
    this.$price.html(this.theme.formatMoney(variant.price));
    this.$sale_price.html(is_sale ? this.theme.formatMoney(variant.compare_at_price) : '');

    if (this.$variantPercentageWrapper.length > 0 && variant.compare_at_price > variant.price) {
      this.$variantPercentageWrapper.removeClass('hide');
      var percentage = (variant.compare_at_price - variant.price) * 100.0 / variant.compare_at_price;
      this.$variantPercentageWrapper.find('.variant-percentage').text(percentage.toFixed(0) + '%');
    } else {
      this.$variantPercentageWrapper.addClass('hide');
    }
    if (this.$variantValueWrapper.length > 0 && variant.compare_at_price > variant.price) {
      this.$variantValueWrapper.removeClass('hide');
      var value = variant.compare_at_price - variant.price;
      this.$variantValueWrapper.find('.variant-value').html(this.theme.formatMoney(value));
    } else {
      this.$variantValueWrapper.addClass('hide');
    }

    if (variant.unit_price_measurement) {
      this.$pricePerUnit.html('<span class="price">(' + this.theme.formatMoney(variant.unit_price) + ' / ' + (variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value : '') + ' ' + variant.unit_price_measurement.reference_unit + ')');
    } else {
      this.$pricePerUnit.text('');
    }

    if (!variant.available) {
      this.showVariantOutOfStockForm(this.product.title, variant.title);
      this.$cart.prop('disabled', true);
      this.$spb.css({ 'opacity': 1 }).animate({ 'opacity': 0 }).hide();
      this.$cart.text(this.theme.translations.soldOut);

      // @ts-ignore
      $.event.trigger({
        type: "variantUnavailable",
        time: new Date(),
        variant: variant
      });
    } else {
      this.hideVariantOutOfStockForm();
      this.$cart.prop('disabled', false);
      this.$spb.show().css({ 'opacity': 1 }).animate({ 'opacity': 1 });
      this.$cart.text(this.theme.translations.addToCart);

      // @ts-ignore
      $.event.trigger({
        type: "variantAvailable",
        time: new Date()
      });
    }
    if (variant.featured_media) {
      const mediaIndex = this.product.media.findIndex(m => m.id === variant.featured_media.id);
      if (mediaIndex >= 0) {
        var $newImageThumb = this.$element.find('.product-single__thumbnail[data-media-id$="' + variant.featured_media.id + '"]');
        this.onMediaElementSelect($newImageThumb[0], { load: true });
        if (this.slider.slidesPerViewDynamic() === 1) {
          // Mobile view active
          this.slider.slideToLoop(mediaIndex);
        }
      }
    }

    var is_indiv_product = this.$element.closest('.shopify-section').hasClass('homepage-section--indiv-product-wrapper');
    var has_more_variants = this.product.variants.length > 1;
    if (window.history.replaceState && !is_indiv_product && has_more_variants) {
      // Change url to include variant if we're not on homepage
      var search = [];
      if (window.location.search.length > 1) {
        // select non-variant query params
        search = window.location.search.slice(1).split('&').filter(function (q) {
          return q.indexOf('variant=') !== 0;
        });
      }
      // add current variant
      search.push('variant=' + variant.id);

      // set the url to include the variant
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + search.join('&');
      window.history.replaceState({ path: newurl }, '', newurl);
    }

    // Swatches
    if (this.$swatchInputs.length > 0) {
      var section_id = this.$element.data('section-id');
      variant.options.forEach((option, index) => {
        this.$swatchInputs.filter('#section-' + section_id + '-swatch-' + index + '-' + toHandle(option)).prop('checked', true);
      });
    }
  }

  handleNullVariant = () => {
    var makeASelection = this.$selects.filter(function (index, select) {
      return $(select).val() === '';
    }).length > 0;

    if (makeASelection) {
      this.$price.text(this.theme.translations.makeASelection);
    } else {
      this.$price.text(this.theme.translations.unavailable);
      this.hideVariantOutOfStockForm();
    }
    this.$cart.prop('disabled', true);
    this.$sale.addClass('hide');
    this.$variantPercentageWrapper.addClass('hide');
    this.$variantValueWrapper.addClass('hide');
    this.$sku.addClass('hide');
  }

  updateVariant = (variant) => {
    if (variant) {
      this.handleVariant(variant);
    } else {
      this.handleNullVariant();
    }
  };

  CART_LOADING = '<div class="lds-dual-ring"></div><span class="sr-only">Loading...</span>';

  addToCart = () => {
    this.clearError();

    $.ajax({
      url: this.config.shopifyAjaxAddUrl,
      dataType: 'json',
      type: 'post',
      data: this.$addToCartForm.serialize(),
      success: this.addedToCart,
      error: this.addToCartFailed,
    });
  };

  disableCartButton = () => {
    if (this.addedTextTimeout) {
      clearTimeout(this.addedTextTimeout);
      this.addedTextTimeout = null;
    }
    this.$cart.addClass('disabled').prop('disabled', true).html(this.CART_LOADING);
  };

  enableCartButton = () => {
    if (this.addedTextTimeout) {
      clearTimeout(this.addedTextTimeout);
      this.addedTextTimeout = null;
    }
    this.$cart.removeClass('disabled').prop('disabled', false).html(this.theme.translations.addToCart);
  };

  addedToCart = (itemData) => {
    this.updateCart();
    // Dispatch event so other components can update
    document.dispatchEvent(new CustomEvent('cart:added'));
  };

  openCartPage = () => {
    window.location.href = this.$addToCartForm.find('#cart-link').val().toString();
  };

  showCart = () => {
    $('.js-cart-drawer-status').text(`Item added to your cart`).appendTo('.cart-drawer__top');
    this.$cartSliderWrapper.trigger('cart:open');
  };

  updateCart = () => {
    $.ajax({
      cache: false,
      url: this.config.shopifyAjaxUrl,
      dataType: "json",
    })
      .then(this.updatedCart)
      .fail(this.updateCartFailed);
  };

  updatedCart = (data) => {
    this.theme.updateCartDrawer(data);
    this.enableCartButton();

    var cart_action = this.$cart.data('cart-action');
    if (cart_action === 'cart') {
      this.openCartPage();
    } else if (cart_action === 'added') {
      this.$cart.html(this.theme.translations.added);
      // Update cart count.
      this.$cartCount.text(data.item_count);

      if (this.addedTextTimeout) {
        clearTimeout(this.addedTextTimeout);
        this.addedTextTimeout = null;
      }

      this.addedTextTimeout = setTimeout(() => {
        this.$cart.html(this.theme.translations.addToCart);
      }, 2000);
    } else {
      // cart_action === drawer
      this.showCart();
    }
  };

  updateCartFailed = (response) => {
    this.enableCartButton();
    console.error("Updating the cart failed: ", response);
  };

  addToCartFailed = (response) => {
    this.enableCartButton();
    var errorText = 'Unknown error';
    if (response.status == 0) {
      // Unable to connect to server
    } else if (response.responseJSON) {
      // Process JSON error
      if (response.responseJSON.description) {
        errorText = response.responseJSON.description;
      } else {
        errorText = response.responseJSON.message;
      }
    } else if (response.responseText) {
      // Use plain text error
      errorText = response.responseText;
    }
    this.showError(errorText);
  };

  showError = (text) => {
    const errorMessage = typeof text === 'object' ? Object.keys(text)[0] + ': ' + text[Object.keys(text)[0]] : text;
    $('<div id="cart-error"></div>')
      .addClass('alert alert-danger')
      .text(errorMessage)
      .insertAfter(this.$cart);
  };

  clearError = () => {
    $('#cart-error').remove();
  };

  loadTabs = () => {
    $('ul.tabs').each(function () {
      const links = $(this).find('a');
      let active = links.first().addClass('active');
      let content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').on('click', function (e) {
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.fadeIn();
        return false;
      });
    });
  }

  loadSlider = () => {
    this.$element.find('.mobile-product-slider').flexslider({
      animation: 'slide',
      directionNav: false,
      controlNav: true,
      startAt: 0,
      slideshow: false
    });
  }

  showVariantOutOfStockForm = (productTitle, variantTitle) => {
    if (this.$element.find('.product-description-main-wrapper').data('stock-email-enabled')) {
      var $outOfStockEmailBody = this.$element.find('#notify-me-wrapper input[name="contact[body]"]');
      var $emailString = `Please notify me when ${productTitle}, variant: ${variantTitle} becomes available.`;
      var varTitleContainer = document.querySelector('#variant_title');
      var getform = document.querySelector('#sold-out');
      var getSubmitBtn = document.querySelector('#notify-me-wrapper .btn');

      if (!varTitleContainer) {
        return
      } else {
        varTitleContainer.innerText = '- ' + variantTitle;
      }

      getform.addEventListener('submit', function () {
        getSubmitBtn.value = "";
      });

      $outOfStockEmailBody.val($emailString);
      this.$element.find(".variant-out-of-stock").fadeIn();
    }
  }

  hideVariantOutOfStockForm = () => {
    if (this.$element.find('.product-description-main-wrapper').data('stock-email-enabled')) {
      this.$element.find(".variant-out-of-stock").hide();
      this.$element.find(".product-page--submit-action").removeClass("hidden");
    }
  }

  responsiveTables = () => {
    this.$element.find('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
  }
}

function toHandle(o) {
  return o.toLowerCase().replace(/[()]/g, '').replace(/[\W]/g, '-');
}

function fixThumbSliderTabindex(slider) {
  // Only make thumbnails from current view tab-navigatable
  var slidesPerView = slider.slidesPerViewDynamic();
  var activeStart = slider.activeIndex;
  var activeEnd = activeStart + slidesPerView;
  slider.slides.each(function (index, slide) {
    var tabindex = (index >= activeStart) && (index < activeEnd) ? '0' : '-1';
    var icon = slide.querySelector('.product-single__media__icon');
    if (icon) {
      icon.setAttribute('tabindex', tabindex);
    }
    $(slide).find('.product-single__media__icon, button, model-viewer, input:not([hidden]), .plyr, iframe, a, select, textarea').attr('tabindex', tabindex);
  });
}
